<template>
  <div>
    <div class="text-2">Connect Wallet</div>
    <div class="d-flex align-center text-4 mt-8">
      <div class="gray--text">01</div>
      <div class="ml-3">Select Network</div>
    </div>
    <v-container class="mt-3">
      <v-row>
        <v-col v-for="item in ecosystems" :key="item.name" cols="6">
          <div
            :class="[
              'ecosystem-item rounded-50 d-flex align-center py-4 px-5',
              {
                'border-primary': item.name === selectedEcosystem.name,
                'border-default': item.name !== selectedEcosystem.name,
                clickable: !initEcosystem,
                'disabled opacity-6':
                  initEcosystem && initEcosystem !== item.name,
              },
            ]"
            @click="setEcosystem(item)"
          >
            <img :src="item.logo" alt="" height="24" />
            <div class="ml-4 text-4">{{ item.name }}</div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="projectsToSelect.length > 1" class="mt-5">
      <div class="d-flex align-center text-4">
        <div class="gray--text">02</div>
        <div class="ml-3">Select Project</div>
      </div>
      <div
        class="d-flex flex-column flex-sm-row justify-sm-center flex-sm-wrap mt-3"
        v-if="projectsToSelect.length > 1"
      >
        <div
          v-for="item in projectsToSelect"
          :key="item.name"
          :class="[
            'project-item rounded-10 d-flex flex-column align-center justify-center pa-2 mt-3 ml-2 mr-2',
            {
              'border-primary': item.name === selectedProject.name,
              'border-default': item.name !== selectedProject.name,
              clickable: !initProject,
              'disabled opacity-6': initProject && initProject !== item.name,
            },
          ]"
          @click="setProject(item)"
        >
          <img
            :src="
              $vuetify.theme.dark
                ? item.logoSmallDark || item.logoSmall
                : item.logoSmall
            "
            alt=""
            height="30px"
            width="30px"
          />
          <div class="text-5 text-center mt-2" style="line-height: 14px">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-8">
      <div class="d-flex align-center text-4">
        <div class="gray--text">
          {{ projectsToSelect.length > 1 ? "03" : "02" }}
        </div>
        <div class="ml-3">Select Wallet</div>
      </div>
    </div>
    <div
      class="d-flex flex-column flex-sm-row justify-sm-center flex-sm-wrap-reverse"
      v-if="walletsToSelect.length > 0"
    >
      <div
        v-for="item in walletsToSelect"
        :key="item.name"
        :class="[
          'wallet-item rounded-10 d-flex flex-column align-center justify-center clickable mt-5 ml-2 mr-2',
          {
            'border-primary': item.name === selectedWallet.name,
            'border-default': item.name !== selectedWallet.name,
          },
        ]"
        @click="selectedWallet = item"
      >
        <img
          :src="$vuetify.theme.dark ? item.logoDark || item.logo : item.logo"
          alt=""
          height="36px"
          width="36px"
        />
        <div class="mt-1 text-5">{{ item.text }}</div>
      </div>
    </div>
    <div class="mt-10 d-flex align-center justify-end">
      <div
        class="text-4 font-weight-medium gray--text clickable"
        @click="closeModal"
      >
        Cancel
      </div>
      <c-btn class="ml-5" :disabled="!selectedWallet.name" @click="setWallet"
        >Connect</c-btn
      >
    </div>
  </div>
</template>

<script>
import ECOSYSTEMS from "@/common/config/ecosystems";
import WALLETS from "@/common/config/wallets";

import { mapGetters } from "vuex";
export default {
  props: ["initData"],
  computed: {
    ...mapGetters({
      projects: "projectConfig/projects",
      authModalState: "authModal",
      isAuthenticated: "auth/isAuthenticated",
    }),
    initEcosystem() {
      return this.initData?.ecosystem;
    },
    initProject() {
      return this.initData?.project;
    },
    initWallet() {
      return this.initData?.wallet;
    },
    projectsToSelect() {
      const prs = this.projects.filter(
        pr =>
          pr.implemented &&
          this.selectedEcosystem.projects?.includes(pr.projectName)
      );
      prs.length = [...new Set(prs.map(pr => pr.config.network))].length;
      if (prs.length > 0 && !this.selectedProject.name) {
        this.selectedProject = prs[0];
      }
      return prs;
    },
    walletsToSelect() {
      return WALLETS.filter(
        w =>
          w.active &&
          w.projects.includes(this.selectedProject.name) &&
          (!w.authRequired || this.isAuthenticated)
      ).reverse();
    },
  },
  data() {
    return {
      ecosystems: ECOSYSTEMS,
      selectedEcosystem: {},
      selectedProject: {},
      selectedWallet: {},
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("closeAuthModal");
    },
    setWallet() {
      this.$emit("setWallet", this.selectedWallet, this.selectedProject);
    },
    setEcosystem(item) {
      if (this.initEcosystem) return;
      this.selectedEcosystem = item;
    },
    setProject(item) {
      if (this.initProject) return;
      this.selectedProject = item;
    },
  },
  mounted() {
    if (this.initEcosystem) {
      this.selectedEcosystem = this.ecosystems.find(
        eco => eco.name === this.initEcosystem
      );
    } else {
      this.selectedEcosystem = this.ecosystems[0];
    }
    this.$nextTick(() => {
      if (this.initProject) {
        this.selectedProject = this.projects.find(
          pr => pr.name === this.initProject
        );
      }
      this.$nextTick(() => {
        if (this.initWallet) {
          this.selectedWallet =
            this.walletsToSelect.find(wl => wl.name === this.initWallet) || {};
          if (this.selectedWallet.name) {
            this.setWallet();
          }
        }
      });
    });
    this.selectedWallet = {};
  },
  watch: {
    ["authModalState.shouldShow"](val) {
      this.selectedEcosystem = this.ecosystems[0];
      this.selectedWallet = {};
    },
    selectedProject(newValue, oldValue) {
      if (newValue?.name !== oldValue?.name) {
        if (this.walletsToSelect.length === 1) {
          this.selectedWallet = this.walletsToSelect[0];
        } else {
          this.selectedWallet = {};
        }
      }
    },
    selectedEcosystem() {
      this.selectedProject = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.ecosystem-item {
  height: 68px;
}
.wallet-item {
  height: 112px;
  min-width: 120px;
  flex: 1;
  padding: 16px 0;
}
.project-item {
  width: 108px;
  height: 108px;
}
</style>
